



























import Vue from 'vue';

export default Vue.extend({
  name: 'HMSimpleActionCard',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    prefixIcon: {
      type: Array,
      default: null,
    },
    prefixImage: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    iconSize: {
      type: String,
      default: null,
    },
  },
});
